import utils from '@/modules/projectA/utils/utils';

const { thousandsSeparator } = utils;
import {
  supplierTypeList,
  reviewTimeOptionList,
  auditStatusList,
  creditRoundList,
  specialtyList
} from '../../components/componentsData';
// 评价状态
export const evaluationStatusList = [
  { name: '全部', id: null },
  { name: '现场审核中', id: '1' },
  { name: '实物测试中', id: '2' },
  { name: '领导审核中', id: '8,9' },
  { name: '现场审核不合格', id: '3' },
  { name: '审核中', id: '4,12,13' },
  { name: '评价完成', id: '5' },
  { name: '实物测试驳回', id: '6,11' },
  { name: '现场审查驳回', id: '7,10' },
  { name: '退款关闭', id: '14' }
];
// 复评生成标记(0:无复评 1:自动 2:关闭 3:手动)
const evaluateFlagList = [
  { name: '全部', id: null },
  { name: '自动', id: '1' },
  { name: '关闭', id: '2' },
  { name: '手动', id: '3' }
];

export const fieldList = [
  {
    label: '申请单号',
    type: 'input',
    value: 'applyCode'
  },
  {
    label: '委托单号',
    type: 'input',
    value: 'commissionNumber'
  },
  {
    label: '评价状态',
    type: 'select',
    value: 'subStatusList',
    list: 'evaluationStatusList'
  },
  {
    label: '评价编码',
    type: 'input',
    value: 'evaluationCode'
  },
  {
    label: '评价类型',
    type: 'select',
    value: 'creditRound',
    list: 'creditRoundList'
  },
  {
    label: '供应商类型',
    type: 'select',
    value: 'supplierType',
    list: 'supplierTypeList'
  },
  {
    label: '专业',
    type: 'select',
    value: 'specialtyId',
    list: 'specialtyList'
  },
  {
    label: '产品名称',
    type: 'input',
    value: 'productName'
  },
  {
    label: '申请企业',
    type: 'input',
    value: 'companyName'
  },
  {
    label: '资料复审时间',
    type: 'select',
    value: 'informationCheckDayCount',
    list: 'reviewTimeOptionList'
  },
  {
    label: '现场审查时间',
    type: 'select',
    value: 'sceneCheckDayCount',
    list: 'reviewTimeOptionList'
  },
  {
    label: '实物测试时间',
    type: 'select',
    value: 'entityCheckDayCount',
    list: 'reviewTimeOptionList'
  },
  {
    label: '申请日期',
    type: 'date',
    dateType: 'daterange',
    value: 'applyTime'
  },
  {
    label: '评价完成日期',
    type: 'date',
    dateType: 'daterange',
    value: 'finishTime'
  }
];

export const listTypeInfo = {
  supplierTypeList,
  reviewTimeOptionList,
  auditStatusList,
  evaluationStatusList,
  specialtyList,
  creditRoundList
};

export const tableLabel = [
  { label: '序号', align: 'center', slot: 'index', width: 50 },
  { label: '申请单号', param: 'applyCode', align: 'center', minWidth: 120 },
  { label: '评价编码', param: 'evaluationCode', align: 'center', minWidth: 120 },
  { label: '专业', param: 'specialtyName', align: 'center', width: 50 },
  { label: '产品名称', param: 'productName', align: 'center', minWidth: 120, tooltip: true },
  { label: '委托单号', slot: 'commissionNumber', align: 'center', minWidth: 120 },
  { label: '申请企业', param: 'companyName', align: 'center', minWidth: 120, tooltip: true },
  {
    label: '供应商类型', param: 'supplierType', align: 'center', minWidth: 120,
    render({ supplierType }) {
      return supplierTypeList.find(item => item.id?.toString() === supplierType)?.name;
    }
  },
  { label: '申请日期', param: 'applyTimeStr', align: 'center', minWidth: 120 },
  { label: '申请人', param: 'applicant', align: 'center', minWidth: 120, tooltip: true },
  {
    label: '初评检测费(元)', param: 'applyAmount', align: 'right', minWidth: 120,
    render({ applyAmount }) {
      return thousandsSeparator(applyAmount);
    }
  },
  {
    label: '复评检测费(元)', param: 'reevaluationAmount', align: 'right', minWidth: 120,
    render({ reevaluationAmount }) {
      return thousandsSeparator(reevaluationAmount);
    }
  },
  { label: '评价类型', param: 'creditRoundDesc', align: 'center', minWidth: 120 },
  { label: '资料复审时间(天)', param: 'informationCheckDayCount', align: 'center', minWidth: 150 },
  { label: '现场审查时间(天)', param: 'sceneCheckDayCount', align: 'center', minWidth: 150 },
  { label: '实物测试时间(天)', param: 'entityCheckDayCount', align: 'center', minWidth: 150 },
  {
    label: '评价状态', param: 'subStatusDesc', align: 'center', minWidth: 120,
    render({ subStatus }) {
      return evaluationStatusList.find(item => item.id?.includes(subStatus))?.name;
    }
  },
  { label: '评价完成日期', param: 'creditStartDateStr', align: 'center', minWidth: 120 },
  { label: '初评订单号', param: 'reApplyCode', align: 'center', minWidth: 120 },
  {
    label: '生成状态', param: 'reEvaluateFlag', align: 'center', minWidth: 120,
    render({ subStatus }) {
      return evaluateFlagList.find(item => item.id === subStatus)?.name;
    }
  },
  {
    label: '操作',
    align: 'center',
    fixed: 'right',
    width: '140',
    slot: 'handle',
    minWidth: 100
  }
];


